import createChangedArmourLocationEntry from '../helpers/createChangedArmourLocationEntry.js'
import isArmourLocationChanged from '../helpers/isArmourLocationChanged.js'
import isEmpty from '../helpers/isEmpty.js'

//--------------------------------
// track armour-location changes
//--------------------------------
export default function trackArmourLocationChanges({
  armour_location,
  original_armour_locations,
  changed_armour_locations,
} = {}) {
  if (
    isEmpty(armour_location) ||
    original_armour_locations === undefined ||
    changed_armour_locations === undefined
  ) {
    return []
  }

  const changedIdx = changed_armour_locations.findIndex((entry) => entry.id === armour_location.id)
  const originalIdx = original_armour_locations.findIndex(
    (entry) => entry.id === armour_location.id,
  )

  if (originalIdx === -1) {
    return changed_armour_locations
  }

  if (changedIdx === -1) {
    if (isArmourLocationChanged(original_armour_locations[originalIdx], armour_location)) {
      changed_armour_locations.push(
        createChangedArmourLocationEntry({
          armour_location_name: armour_location.armour_location_name || armour_location.name || '',
          id: armour_location.id,
          action: 'UPDATE',
          payload: {
            hp_cur: armour_location.hp_cur,
          },
        }),
      )
    }

    return changed_armour_locations
  }

  if (isArmourLocationChanged(original_armour_locations[originalIdx], armour_location)) {
    changed_armour_locations[changedIdx].payload.hp_cur = armour_location.hp_cur
  } else {
    changed_armour_locations.splice(changedIdx, 1)
  }

  return changed_armour_locations
}
